"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
exports.MessageImage = exports.MessageImageV2 = exports.MessageImagePlaceholder = exports.MessageImageWithSrc = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = __importDefault(require("react"));
var styled_1 = require("@hiyllo/ux/styled");
var react_native_1 = require("react-native");
var contexts_1 = require("../contexts");
var use_message_image_src_1 = require("../hooks/use-message-image-src");
var calculate_dimensions_with_constraints_1 = require("../lib/calculate-dimensions-with-constraints");
var Container = (0, styled_1.styledRN)(react_native_1.View, {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 20,
    overflow: 'hidden'
});
function getUrlExtension(url) {
    var _a, _b;
    return (_b = (_a = url.split(/[#?]/)[0].split('.').pop()) === null || _a === void 0 ? void 0 : _a.trim()) !== null && _b !== void 0 ? _b : null;
}
// function downloadWeb (src: string): void {
//   if (src != null) {
//     const extension = getUrlExtension(src);
//     const a = document.createElement('a');
//     a.href = src;
//     a.download = `download.${extension as string}`;
//     a.click();
//   }
// }
exports.MessageImageWithSrc = react_1["default"].memo(function MessageImageWithSrc(props) {
    var _a, _b;
    var _c = react_1["default"].useState((_a = props.width) !== null && _a !== void 0 ? _a : 1), nativeWidth = _c[0], setNativeWidth = _c[1];
    var _d = react_1["default"].useState((_b = props.height) !== null && _b !== void 0 ? _b : 1), nativeHeight = _d[0], setNativeHeight = _d[1];
    var Image = react_1["default"].useContext(contexts_1.OverrideImageComponentContext);
    var onLoad = react_1["default"].useCallback(function (evt) {
        if ('source' in evt.nativeEvent && evt.nativeEvent.source != null) {
            setNativeHeight(evt.nativeEvent.source.height);
            setNativeWidth(evt.nativeEvent.source.width);
        }
        else {
            if ('height' in evt.nativeEvent) {
                setNativeHeight(evt.nativeEvent.height);
                setNativeWidth(evt.nativeEvent.width);
            }
            else {
                react_native_1.Image.getSize(props.imageSrc, function (width, height) {
                    setNativeHeight(height);
                    setNativeWidth(width);
                });
            }
        }
    }, [props.imageSrc]);
    var _e = (0, calculate_dimensions_with_constraints_1.calculateDimensionsWithConstraints)({
        maxWidth: props.maxWidth,
        maxHeight: props.maxHeight,
        nativeWidth: nativeWidth,
        nativeHeight: nativeHeight
    }), resolvedWidth = _e.width, resolvedHeight = _e.height;
    if (isNaN(resolvedHeight) || isNaN(resolvedWidth)) {
        console.warn('MessageImage computation data, NaN detected', {
            mw: props.maxWidth,
            nh: nativeHeight,
            nw: nativeWidth,
            resolvedHeight: resolvedHeight,
            resolvedWidth: resolvedWidth
        });
    }
    return ((0, jsx_runtime_1.jsx)(Container, { children: (0, jsx_runtime_1.jsx)(Image, { source: { uri: props.imageSrc }, onLoad: onLoad, style: {
                width: resolvedWidth,
                height: resolvedHeight
            }, resizeMode: 'contain' }) }));
});
exports.MessageImagePlaceholder = react_1["default"].memo(function MessageImagePlaceholder(props) {
    var BlobCache = react_1["default"].useContext(contexts_1.BlobCacheProviderContext);
    if (BlobCache == null) {
        throw new Error('BlobCacheProviderContext is null');
    }
    var _a = (0, calculate_dimensions_with_constraints_1.calculateDimensionsWithConstraints)({
        maxWidth: props.maxWidth,
        maxHeight: props.maxHeight,
        nativeWidth: props.dimensions.width,
        nativeHeight: props.dimensions.height
    }), resolvedWidth = _a.width, resolvedHeight = _a.height;
    return ((0, jsx_runtime_1.jsx)(Container, { children: (0, jsx_runtime_1.jsx)(react_native_1.View, __assign({ style: {
                width: resolvedWidth,
                height: resolvedHeight,
                backgroundColor: 'rgba(255, 255, 255, 0.05)',
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center'
            } }, { children: (0, jsx_runtime_1.jsx)(BlobCache.LoadingComponent, {}) })) }));
});
exports.MessageImageV2 = react_1["default"].memo(function MessageImageV2(props) {
    var _a, _b, _c, _d, _e;
    var src = (0, use_message_image_src_1.useMessageImageSrc)(props.messageUUID);
    return (src === null ?
        (0, jsx_runtime_1.jsx)(exports.MessageImagePlaceholder, { dimensions: (_a = props.imageContent.dimensions) !== null && _a !== void 0 ? _a : {
                height: 1,
                width: 1
            }, maxWidth: props.maxWidth, maxHeight: props.maxHeight })
        :
            (0, jsx_runtime_1.jsx)(exports.MessageImageWithSrc, { imageSrc: src, height: (_c = (_b = props.imageContent.dimensions) === null || _b === void 0 ? void 0 : _b.height) !== null && _c !== void 0 ? _c : 1, width: (_e = (_d = props.imageContent.dimensions) === null || _d === void 0 ? void 0 : _d.width) !== null && _e !== void 0 ? _e : 1, maxWidth: props.maxWidth, maxHeight: props.maxHeight }));
});
exports.MessageImage = react_1["default"].memo(function MessageImage(props) {
    if (!('fileId' in props.imageContent)) {
        return ((0, jsx_runtime_1.jsx)(react_native_1.View, {}));
    }
    return ((0, jsx_runtime_1.jsx)(exports.MessageImageV2, { messageUUID: props.messageUUID, imageContent: props.imageContent, maxWidth: props.maxWidth, maxHeight: props.maxHeight }));
});
